// UserProfile.js
import { connect } from 'react-redux';

import { USER_PROFILE_HOME_CATEGORIES } from '../RemoteConfigKeys.js';

import Profile from '../page/Profile.jsx';

import getMeData from '../selector/getMeData.js';
import getUserData from '../selector/getUserData.js';
import getShortLinkData from '../selector/getShortLinkData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getNetworkingSummary from '../selector/getNetworkingSummary.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getFeedName from '../selector/getFeedName.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';
import getProfileFeedUnixTimestamp from '../selector/getProfileFeedUnixTimestamp.js';

import { replace } from '../action/navigationAction.js';
import fetchUser from '../action/fetchUser.js';
import fetchUserIsFollowing from '../action/fetchUserIsFollowing.js';
import fetchUserIsBlocked from '../action/fetchUserIsBlocked.js';
import fetchShortLink from '../action/fetchShortLink.js';
import fetchUserSubscription from '../action/fetchUserSubscription.js';
import fetchUserFollowersTotalCount from '../action/fetchUserFollowersTotalCount.js';
import fetchUserFollowingTotalCount from '../action/fetchUserFollowingTotalCount.js';
import fetchFeeds, { getReturnType } from '../action/fetchFeeds.js';
import fetchFeedsTotalCount from '../action/fetchFeedsTotalCount.js';
import addModal from '../action/addModal.js';
import toggleModal from '../action/toggleModal.js';

import getShareLink from '../resource/getShareLink.js';
import {
  ProfileListType,
  PROFILE_FEED_REMOTE_CONFIG_KEY_MAP,
} from '../resource/profileConstants.js';
import { QueryPrefix, QueryType } from '../resource/feedConstants.js';

const mapStateToProps = (state, { userId, listType }) => {
  const postBaseFeedName = getFeedName(
    state,
    PROFILE_FEED_REMOTE_CONFIG_KEY_MAP[ProfileListType.POST],
    '{USER_ID}',
    userId
  );
  const { feedNameWithQuery: postFeedNameWithQuery } =
    getSelectedQueryOptionObject(state, postBaseFeedName);
  const feedNameRemoteConfigKey = PROFILE_FEED_REMOTE_CONFIG_KEY_MAP[listType];
  const outboxFeedName = getFeedName(
    state,
    feedNameRemoteConfigKey,
    '{USER_ID}',
    userId
  );

  const { feedNameWithQuery } = getSelectedQueryOptionObject(
    state,
    outboxFeedName,
    getSelectedFeedQueryOptions(state, feedNameRemoteConfigKey, undefined),
    getRemoteConfigData(
      state,
      `${feedNameRemoteConfigKey}_${QueryPrefix[QueryType.SORT]}`
    )?.[0]
  );
  const categories = getRemoteConfigData(
    state,
    USER_PROFILE_HOME_CATEGORIES,
    undefined,
    {
      USER_ID: userId,
    }
  );
  const firstFeedNameWithQuery =
    ProfileListType.HOME === listType ? categories?.[0] : feedNameWithQuery;
  const firstFeedListSelectPath = [
    'home',
    getReturnType({ feedName: firstFeedNameWithQuery }),
    firstFeedNameWithQuery,
  ];
  const shareLink = getShareLink();
  return {
    feedNameWithQuery,
    postFeedNameWithQuery,
    listType,
    meId: getMeData(state, 'id'),
    userId,
    shareLink,
    shortShareLink: getShortLinkData(state, shareLink),
    profileFeedUnixTimestamp: getProfileFeedUnixTimestamp(
      state,
      userId,
      listType
    ),
    userDetailFetchStatus: getNetworkingSummary(state, ['user', userId]),
    isFirstPageFetched: getNetworkingData(
      state,
      [...firstFeedListSelectPath, 1],
      'isFetched'
    ),
    isFirstPageFetching: getNetworkingData(
      state,
      [...firstFeedListSelectPath, 1],
      'isFetching'
    ),
    lastModifiedAtUnix: getUserData(state, userId, 'lastModifiedAtUnix'),
    categories,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    replace: ({ pathname }) => dispatch(replace(pathname)),
    fetchUser: ({ userId, httpProxyHeaders }) =>
      dispatch(fetchUser({ id: userId, httpProxyHeaders })),
    fetchUserIsFollowing: ({ userId }) =>
      dispatch(fetchUserIsFollowing({ userId })),
    fetchUserIsBlocked: ({ userId }) =>
      dispatch(fetchUserIsBlocked({ userId })),
    fetchShortLink: ({ location }) => dispatch(fetchShortLink({ location })),
    fetchUserSubscription: ({ userId }) =>
      dispatch(fetchUserSubscription({ userId })),
    fetchUserFollowersTotalCount: ({ userId, httpProxyHeaders }) =>
      dispatch(fetchUserFollowersTotalCount({ userId, httpProxyHeaders })),
    fetchUserFollowingTotalCount: ({ userId, httpProxyHeaders }) =>
      dispatch(fetchUserFollowingTotalCount({ userId, httpProxyHeaders })),
    fetchFeeds: payload => dispatch(fetchFeeds(payload)),
    fetchFeedsTotalCount: payload => dispatch(fetchFeedsTotalCount(payload)),
    addModal: ({ id }) =>
      dispatch(addModal({ id, transitionStatus: 'opening' })),
    toggleModal: ({ modalId, payload, isOpen }) =>
      dispatch(toggleModal({ modalId, payload, isOpen })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
